import { parseText } from './textMarkupParser';

export function parseWithEndTag(text: string, endTag: string) {
  const contentEnd = text.indexOf(endTag);

  const content = contentEnd !== -1 ? text.substring(0, contentEnd - 1) : text;
  const parsedText = parseText(content);

  return {
    parsedText,
    consumedLength: content.length + endTag.length + 2, // + 2 are the pipes around the endTag
  };
}
